import TimeFormatter from '../../helpers/TimeFormatter';
import TranslationHelper from '../../helpers/TranslationHelper';
import {
    EAttributeType,
    ICustomerServiceAttribute,
} from '../../models/customerService';
import { IReportEntity, IReportEntityActions } from '../types';

export const toLocalizedValue = (attribute: ICustomerServiceAttribute) => {
    const { value, type } = attribute;

    switch (type) {
        case EAttributeType.BOOLEAN:
            return TranslationHelper.translate(value as string);
        case EAttributeType.DATE:
            return TimeFormatter.dateToShortDateString(value as string);
        case EAttributeType.TIME:
            return TimeFormatter.timeToTimeString(value as string);
        case EAttributeType.DATETIME:
            return TimeFormatter.dateToDateTimeString(value as string);
        default:
            return value.toString();
    }
};

export const toTextEntity = (
    id: string,
    label: string,
    value?: string,
    actions?: IReportEntityActions
): IReportEntity | undefined => {
    if (!value) {
        return undefined;
    }
    return {
        id: id,
        label: TranslationHelper.translate(label),
        value: value || '',
        type: 'text',
        actions,
    };
};

export const toDateEntity = (
    id: string,
    label: string,
    value?: string
): IReportEntity | undefined => {
    if (!value) {
        return undefined;
    }
    return {
        id: id,
        label: TranslationHelper.translate(label),
        value: TimeFormatter.dateToDateTimeString(value) || '',
        type: 'time',
    };
};
export const toNumberEntity = (
    id: string,
    label: string,
    value?: number
): IReportEntity | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }

    return {
        id,
        label: TranslationHelper.translate(label),
        value,
        type: 'number',
    };
};

export const toBooleanEntity = (
    id: string,
    label: string,
    value?: boolean
): IReportEntity | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }

    return {
        id,
        label: TranslationHelper.translate(label),
        value,
        type: 'boolean',
    };
};

export const toDateTimeEntity = (
    id: string,
    label: string,
    value?: string
): IReportEntity | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }

    return {
        id,
        label: TranslationHelper.translate(label),
        value,
        type: 'date',
    };
};

export const toBinaryEntity = (
    id: string,
    fileName: string,
    actions: IReportEntityActions
): IReportEntity => {
    return {
        id,
        label: fileName,
        value: { name: fileName, '@type': 'binary' },
        type: 'binary',
        actions,
    };
};
